// ABOUTME: Provider for the form submission / unsaved-changes state
// ABOUTME: The context and hook live in useWatchConfirmSubmitContext.ts

import type { FC, ReactNode } from "react"
import { useMemo, useState } from "react"
import {
  WatchConfirmSubmitContext,
  type WatchConfirmState,
  type WatchConfirmSubmitContextProps,
} from "./useWatchConfirmSubmitContext"

const initialState: WatchConfirmState = {
  isConfirmChange: false,
  isSubmit: false,
  isDontSave: false,
  pendingNavigationUrl: null,
}

export const WatchConfirmSubmitProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [watchConfirm, setWatchConfirm] = useState(initialState)

  const value = useMemo<WatchConfirmSubmitContextProps>(() => ({ watchConfirm, setWatchConfirm }), [watchConfirm])

  return <WatchConfirmSubmitContext.Provider value={value}>{children}</WatchConfirmSubmitContext.Provider>
}
